<template>
  <!-- NOTE (TEMPLATE) to show the users -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/admin/users'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <!-- NOTEadd new researcher btn -->

      <b-button variant="success" class="mb-3" @click="gotoNewResearcher()">
        <strong>پژوهشگر جدید + </strong>
      </b-button>
      <v-row class="header-box btn-radius pa-1 ps-2" style="margin: 0 1px 15px">
        <v-col>
          <h4 style="margin-top: 9px">پژوهشگران</h4>
        </v-col>
        <v-col>
          <v-btn
            class="bc-primary text-white btn-radius float-end"
            width="200"
            height="45"
            elevation="0"
            :disabled="isBusy || !computedItems.length"
            @click="$refs.table1.$el.click()"
          >
            <span class="fs-small">
              خروجی اکسل

              <v-icon>$Excel</v-icon></span
            >
          </v-btn>
          <vue-excel-xlsx
            v-show="false"
            ref="table1"
            :data="computedItems"
            :columns="excelFields"
            :filename="'لیست پژوهشگران'"
            :sheetname="currentDate"
          >
            دریافت اکسل
          </vue-excel-xlsx>
        </v-col>
      </v-row>
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>

          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-users) to show the users list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="computedItems"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="هنوز طرحی ثبت نشده است"
        striped
        :busy="isBusy"
        :filter="filter"
        :filterIncludedFields="filterOn"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div
            style="
              text-align: center;
              vertical-align: middle;
              width: 150px;
              margin: auto;
            "
          >
            <!-- NOTE <a> to go to the user profile page -->
            <a
              class="btn text-light btn-primary mx-1"
              :href="'/admin/user/' + data.item.id"
              target="_blank"
              style="width: 100%"
              >مشاهده پروفایل</a
            >
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import moment from "moment-jalaali";

export default {
  components: {},
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      fields: [
        { key: "index", label: "ترتیب" },
        // { key: "id", label: "" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "natCode", label: "شماره ملی" },
        { key: "lastDegree", label: "آخرین مدرک تحصیلی" },
        { key: "university", label: "دانشگاه" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        // { field: "id", label: "" },
        { field: "name", label: "نام و نام خانوادگی" },
        { field: "natCode", label: "شماره ملی" },
        { field: "lastDegree", label: "آخرین مدرک تحصیلی" },
        { field: "university", label: "دانشگاه" },
        { field: "status", label: "وضعیت" },
      ],
      items: [],
      filter: "",
      filterOn: [],
      isBusy: true,
    };
  },
  computed: {
    computedItems() {
      if (this.items) {
        return this.items.sort((a, b) => {
          if (a.code < b.code) {
            return 1;
          }
          if (a.code > b.code) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
  },
  watch: {
    $route: function () {
      this.onMounted();
    },
  },
  methods: {
    gotoNewResearcher() {
      router.push("/admin/addUser");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.isBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/researchers/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.totalRows = this.items.length;
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });
    },
  },
  mounted() {
    this.onMounted();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
